import React from 'react';
import { Logo } from '../logo/logo';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-plt-bg pt-12 pb-12">
      <div className="w-fit mx-auto">
        <Logo />
      </div>
      <p className="text-center max-w-[1022px] mx-auto mt-9 text-plt-white leading-[120%] font-gilroy">
        Продолжая использовать наш сайт и отправляя любую форму на сайте, Вы
        даете согласие на обработку файлов Cookies и других пользовательских
        данных, в соответствии с
        <a className="underline" href="/assets/doc/Politika-konf_futurist.doc">
          политикой конфиденциальности
        </a>
        , а также соглашаетесь на получение рассылки на электронную почту,
        указанную в заявке. Запретить обработку Cookies можно в настройках
        Вашего браузера.
      </p>
      <p className="text-center max-w-[1022px] mx-auto mt-9 text-plt-white leading-[120%] font-gilroy">
        ООО СЗ «Футурист»
        ИНН 2536305520
        ОГРН 1172536031843 {" "}
        {currentYear?.toString()?.toUpperCase()}Г
      </p>
    </footer>
  );
};
